// Constants
import { BETWEEN, METRIC_FILTER_OPERATOR_REGEX_EXP, METRIC_FILTER_NUMBER_REGEX_EXP, METRIC_FILTER_PARENTHESES_REGEX_EXP, MIDDLE_EXPRESSION_LABEL_MAP, PERCENTILE_OPERATORS, PERCENTILE_SEQUENTIAL, PERCENTILE_UNIVERSE, RANK_OPERATORS, RANK_SEQUENTIAL, RANK_UNIVERSE, TOKEN_IS_EDITING, } from 'ScreenerApp/ts/features/screener/constants';
// Utils
import { getBasicFormatted } from 'NewAngular/utils/number_formatter';
const getPercentileFilterValues = (metricFilter) => {
    const isPercentileFilter = PERCENTILE_OPERATORS.indexOf(metricFilter.middle) !== -1;
    const right = metricFilter.right;
    if (isPercentileFilter && metricFilter.right.length === 4) {
        return {
            percentileType: metricFilter.middle === PERCENTILE_SEQUENTIAL ? 'Sequential' : 'Universe',
            topOrBottom: right[0].toUpperCase(),
            ordinal: parseInt(right[1], 10),
            quantileSize: right[2],
            highOrLow: right[3] === 'higher_value_is_better' ? '(Higher is Better)' : '(Lower is Better)',
        };
    }
    return {};
};
const getRankFilterValues = (metricFilter) => {
    const isRankFilter = RANK_OPERATORS.indexOf(metricFilter.middle) !== -1;
    const right = metricFilter.right;
    if (isRankFilter && metricFilter.right.length === 3) {
        return {
            rankType: metricFilter.middle === RANK_SEQUENTIAL ? 'Sequential Ranking' : 'Universe Ranking',
            topOrBottom: right[0].toUpperCase(),
            ordinal: parseInt(right[1], 10),
            highOrLow: right[2] === 'higher_value_is_better' ? '(Higher is Better)' : '(Lower is Better)',
        };
    }
    return {};
};
export const getMetricFilterPartialDescriptionForToken = (token, metricLabelMap) => {
    if (!metricLabelMap)
        return '';
    // is operator, parenthesis OR special `isEditing` value
    if (token === TOKEN_IS_EDITING ||
        METRIC_FILTER_OPERATOR_REGEX_EXP.test(token) ||
        METRIC_FILTER_PARENTHESES_REGEX_EXP.test(token))
        return token;
    // is metric
    const metric = metricLabelMap[token];
    if (metric !== undefined)
        return metric;
    // is number
    if (METRIC_FILTER_NUMBER_REGEX_EXP.test(token)) {
        return getBasicFormatted(Number(token), 'figure');
    }
    return '';
};
const getMetricFilterPartialDescription = (metricFilterPartial, metricLabelMap) => {
    return metricFilterPartial
        .map((token) => getMetricFilterPartialDescriptionForToken(token, metricLabelMap))
        .join(' ');
};
const getLeftDescription = (metricFilter, metricLabelMap) => {
    return getMetricFilterPartialDescription(metricFilter.left, metricLabelMap);
};
const getRightDescription = (metricFilter, metricLabelMap) => {
    return getMetricFilterPartialDescription(metricFilter.right, metricLabelMap);
};
export const getMetricFilterDescription = (metricFilter, metricLabelMap, filterData) => {
    const right = metricFilter.right;
    let leftDescription;
    let middleDescription;
    let rightDescription;
    let metricFilterDescription = '';
    if (!metricLabelMap) {
        return metricFilterDescription;
    }
    const { middle } = metricFilter;
    switch (middle) {
        case BETWEEN:
            const metric = metricFilter.left[0];
            const metricType = filterData[metric] ? filterData[metric].type : 'figure';
            leftDescription = getBasicFormatted(parseFloat(right[0]), metricType);
            middleDescription = metricLabelMap[metricFilter.left[0]];
            rightDescription = getBasicFormatted(parseFloat(right[1]), metricType);
            metricFilterDescription = `${leftDescription} < ${middleDescription} < ${rightDescription}`;
            break;
        case PERCENTILE_SEQUENTIAL:
        case PERCENTILE_UNIVERSE:
            leftDescription = getLeftDescription(metricFilter, metricLabelMap);
            const percentileValues = getPercentileFilterValues(metricFilter);
            metricFilterDescription = `${leftDescription} in ${percentileValues.topOrBottom} ${percentileValues.ordinal} ${percentileValues.percentileType} ${percentileValues.quantileSize} ${percentileValues.highOrLow}`;
            break;
        case RANK_SEQUENTIAL:
        case RANK_UNIVERSE:
            leftDescription = getLeftDescription(metricFilter, metricLabelMap);
            const rankOptions = getRankFilterValues(metricFilter);
            metricFilterDescription = `${leftDescription} in ${rankOptions.topOrBottom} ${rankOptions.ordinal} ${rankOptions.rankType} ${rankOptions.highOrLow}`;
            break;
        default:
            leftDescription = getLeftDescription(metricFilter, metricLabelMap);
            rightDescription = getRightDescription(metricFilter, metricLabelMap);
            // @ts-ignore
            middleDescription = MIDDLE_EXPRESSION_LABEL_MAP[middle];
            metricFilterDescription = `${leftDescription} ${middleDescription} ${rightDescription}`;
            break;
    }
    return metricFilterDescription;
};
